import { Box, BoxProps } from '@modusign/design-system';
import { ReactNode } from 'react';

interface TextCellProps extends BoxProps<'div'> {
  children: ReactNode;
}

export default function ResponsiveTableCell({ children, ...props }: TextCellProps) {
  return (
    <Box p={6} px={[4, 6]} {...props}>
      {children}
    </Box>
  );
}
